import React from 'react';
import { connect } from 'react-redux';
import {MasterLayout} from 'layout';
import classnames from 'classnames';
import { Button, Collapse } from "@blueprintjs/core";
import {TrangChu} from 'api';
import moment from 'moment';
import {header} from "constants/table";
import {browserHistory} from 'react-router';
import {TextMessage} from 'components/tt-forms/common';
import RowItemDocumentDetail from './RowItemDocumentDetail.jsx';
import DataTable from 'components/data-table';
import {ShowIf} from 'components/utils';
import {
  ThongTinNguoiDungDon,
  ThongTinDonVuViec,
  ThongTinCoQuanDaGiaiQuyet,
  ThongTinNguoiUyQuyen
} from 'modules/letter-information/letter-detail';
import { loadReCaptcha, ReCaptcha } from 'react-recaptcha-google';
import { siteKey } from 'constants/config';

let nfIcon = require('assets/images/file-nf.svg');
class KetQuaCongDanTraCuu extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      searchKey: this.props.params.keySearch,
      data: {},
      loaiNguoiDungDon: '',
      dataNguoiDungDon: [],
      dataDoanDiCung: [],
      loaiDonGiaTri: '',
      loaiDon: '',
      loaiDoiTuong: {},
      listTaiLieuBangChung: [],
      listTepChungChiHanhNghe: [],
      lichSuTrangThaiXLGQDons: '',
      listTepUyQuyen: [],
      loading: false,
      ready: false,
      onOffForm: false,
      isOpen: false
    }
    this.onLoadRecaptcha = this.onLoadRecaptcha.bind(this);
    this.verifyCallback = this.verifyCallback.bind(this);
  }
  componentDidMount() {
    this.searchData(this.props.params.keySearch);
    loadReCaptcha();
  }
  onLoadRecaptcha() {}

  verifyCallback(response) {
    if (response) {
      this.setState({
        ready : true,
        onOffForm: true
      })
    }
    this.searchData(this.state.searchKey);
  }
  onChange(name, e) {
    this.setState({[name]: e.target.value});
  }

  handleSearch(e) {
    e.preventDefault();
    if (this.state.ready && this.state.searchKey) {
      this.searchData(this.state.searchKey);
    }
  }

  searchData(key) {
    if (typeof key !== 'string') return;
    let searchKey = key.trim();
    browserHistory.push({
      pathname: '/ket-qua-cong-dan-tra-cuu/'+searchKey,
    });
    this.setState({
      loading: true
    });
    TrangChu.actions.getTraCuuDonCongDan.request(null, {maDon: searchKey}).then(res => {
      if (res.data) {
        this.setState({
          data: {...res.data,
            loaiNguoiDungDon : res.data.loaiNguoiDungDonInfo.giaTri,
            loaiVuViecInfo : {ten: res.data.loaiVuViec}
          },
          loaiNguoiDungDon : res.data.loaiNguoiDungDonInfo.giaTri,
          dataNguoiDungDon : res.data.listNguoiDungDon,
          dataDoanDiCung : res.data.listDoanDiCung,
          loaiDon : res.data.loaiDonThuInfo.ten,
          loaiDonGiaTri : res.data.loaiDonThuInfo.giaTri,
          loaiDoiTuong : {ten: res.data.loaiDoiTuong},
          linhVuc : res.data.linhVucDonThu,
          linhVucChiTiet : res.data.linhVucDonThuChiTiet,
          linhVucChiTietSub : res.data.linhVucChiTietKhac,
          noiDung : res.data.noiDung,
          dataNguoiDuocUyQuyen : res.data.nguoiDuocUyQuyen,
          loading: false
        });
        if (res.data.trangThaiDonType === 'DA_XU_LY' || res.data.trangThaiDonType === 'DA_GIAI_QUYET') {
          TrangChu.actions.getLichSuTrangThaiXLGQDons.request(null, {maDon: searchKey}).then(res => {
            if (res.data && res.data._embedded) {
              this.setState({
                lichSuTrangThaiXLGQDons: res.data._embedded.lichSuTrangThaiXLGQDons
              });
            }
          });
        }
      }
    }).catch(error => {
      this.setState({
        loading: false,
        loaiDon: ''
      });
    });
  }

  handleClick() {
    this.setState({isOpen: !this.state.isOpen});
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name} type={this.props.route.type}>
        <div className="panel-page">
          <div className="center">
            <div className="main_page">
              <div className="wrapper_box tc-box tc-style-search">
                <form onSubmit={ this.handleSearch.bind(this) }>
                  <div className="search-group">
                    <input type="text" name="searchKey" placeholder="Nhập mã đơn..." className="tc-input full no-shadow" onChange={ this.onChange.bind(this, 'searchKey') }
                      value={this.state.searchKey} disabled={this.state.onOffForm === false ? 'disabled' : ''}/>
                      <ReCaptcha
                        render="explicit"
                        sitekey={siteKey}
                        verifyCallback={this.verifyCallback}
                        onloadCallback={this.onLoadRecaptcha}
                        onSuccess={token => console.log(token)}
                        onError={console.error.bind(console)}
                        hl="vi"
                      />
                    <button type="submit" className={classnames('tc-bt margin-bt-kqtr no-shadow', {
                      'btn-loading-inline': this.state.loading,
                      'no-drop': !this.state.onOffForm
                    })}>
                      <span>Tra cứu</span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="heading">
              <h2 className="heading-title icon-search">Kết quả tìm kiếm</h2>
            </div>
            <ShowIf condition={!this.state.loading}>
              <div className="main_page">
                {
                  this.state.loaiDon ?
                    <div className="wrapper_box mb30">
                      <div className="page-wrapper mt0">
                        <div className="content-wrap content-gqd background-detail panel-page">
                          <div className="header-redirect background-detail">
                            <div className="box-items no-border">
                              <div className="row-col">
                                <TextMessage className="header-col pl15" label="Mã đơn:" value={this.state.data.maHoSo || ''} />
                                <TextMessage className="header-col" label="Ngày tiếp nhận:" value={this.state.data.ngayTao ? moment(this.state.data.ngayTao).format('DD/MM/YYYY') : ''} />
                                <TextMessage className="header-col" label="Nguồn đơn:" value={this.state.data.nguonDon} />
                                <div className="header-col"></div>
                                <div className="pull-right pr15">
                                  <Button onClick={this.handleClick.bind(this)} className={classnames('btn-collap', {'active': this.state.isOpen})} />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="wrap-block pl10 pr10 pt10">
                            <div className="wrap-blocks">
                              <Collapse isOpen={this.state.isOpen}>
                                <ThongTinNguoiDungDon
                                  title="Thông tin người đứng đơn/Vụ việc"
                                  parent={this.state}
                                />
                              </Collapse>
                              <ShowIf condition={this.state.data.coUyQuyen}>
                                <Collapse isOpen={this.state.isOpen}>
                                  <ThongTinNguoiUyQuyen
                                    title="Thông tin người được ủy quyền"
                                    parent={this.state}
                                  />
                                </Collapse>
                              </ShowIf>
                              <div className={classnames('box-items', {'no-margin': !this.state.isOpen})}>
                                <ThongTinDonVuViec
                                  title="Thông tin đơn/Vụ việc"
                                  isOpen={this.state.isOpen}
                                  parent = {this.state}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="page-wrapper">
                        <div className="box-items no-border">
                          <div className="title">
                            <div className="rows">
                              <div className="col-12">
                                <h3>Tình trạng</h3>
                              </div>
                            </div>
                          </div>
                          <div className="items-form">
                            <div className="rows">
                              <TextMessage className="col-input" label="Trạng thái đơn:" value={this.state.data.trangThaiDon || ''} />
                              <TextMessage className="col-input" label="Cơ quan xử lý:" value={this.state.data.tenDonViGiuDenHienTai || ''} />
                            </div>
                          </div>
                        </div>
                      </div>
                      <ShowIf condition={this.state.lichSuTrangThaiXLGQDons && this.state.lichSuTrangThaiXLGQDons.length}>
                        <div className="page-wrapper">
                          <div className="box-items no-border">
                            <div className="box-forward">
                              <div className="title">
                                <div className="rows">
                                  <div className="col-12">
                                    <h3>Quá trình xử lý</h3>
                                  </div>
                                </div>
                              </div>
                              <div className="items-form">
                                <div className="rows">
                                  <div className="col-12">
                                    <DataTable
                                      header={header.listTTXLGQD}
                                      dataList={this.state.lichSuTrangThaiXLGQDons}
                                      hidePagination={true}>
                                      <RowItemDocumentDetail/>
                                    </DataTable>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ShowIf>
                    </div>
                  :
                    <div className="wrapper_box tc-box not-found">
                      <div className="box">
                        <img src={nfIcon} alt="not-found" />
                        <div className="content">
                          <p>
                            Không tìm thấy kết quả nào phù hợp với mã đơn tra cứu <span>"{this.state.searchKey}"</span>
                          </p>
                          <p>
                            Vui lòng tra cứu lại.
                          </p>
                        </div>
                      </div>
                    </div>
                }
              </div>
            </ShowIf>
          </div>
        </div>
      </MasterLayout>
    );
  }
}

let bindStateToProps = state => {
  return {
  }
}

export default connect(bindStateToProps)(KetQuaCongDanTraCuu);



// WEBPACK FOOTER //
// ./src/components/modules/tra-cuu/KetQuaCongDanTraCuu.jsx